import { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SelectPrice } from './SelectPrice';
import { SelectLocation } from './SelectLocation';
import { SelectEquipment } from './SelectEquipment';
import { useDispatch } from 'react-redux';
import { filterEquipment } from '../redux/slices/equipmentsSlice';

const EquipmentFilter = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    price: '',
    location: '',
    equipmentType: '',
    date: '',
    searchTerm: '',
  });

  const handleFindEquipment = () => {
    // Dispatch the filter action with the current filters
    dispatch(filterEquipment({ ...filters, searchTerm }));
  };

  return (
    <div className="hidden md:flex mx-auto max-w-4xl w-full rounded-full bg-[#A8C356] mt-10 p-2 shadow-md">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="flex flex-wrap items-center justify-between w-full gap-2 px-3">
          <div className="flex-shrink-0">
            <input
              type="text"
              placeholder="Search equipment..."
              className="rounded-full py-2 px-4 text-sm w-40 focus:outline-none focus:ring-2 focus:ring-[#156326] transition-all"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="flex items-center space-x-2 flex-grow justify-evenly">
            <SelectPrice setFilters={setFilters} />
            <SelectLocation setFilters={setFilters} />
            <SelectEquipment setFilters={setFilters} />
          </div>

          <button
            className="bg-[#156326] hover:bg-[#1563269c] text-white font-bold py-2 px-4 rounded-full flex-shrink-0 transition-colors duration-200"
            onClick={handleFindEquipment}
          >
            Find Equipment
          </button>
        </div>
      </LocalizationProvider>
    </div>
  );
};

export { EquipmentFilter };
